import { html } from "lit-html";
import { BallPointPenJsEnv } from "../../../models/ballpoint_pen/ballpoint_pen_js_env";
import { BallPointPenMakerArea, BallPointPenSeriesArea, BallPointPenSizesArea } from "./ballpoint_pens";
import { encodeString } from "../../../util/browser_util";

const BASE_URL = `${window.location.protocol}//${window.location.host}/`
const REFINEMENT_SEARCH_TYPE_BALLPOINTPEN = 1;

export const BallPointPenArea = (model: BallPointPenJsEnv) => html`
<div class="o-menuBar_ballpointpen">
<p class="o-menuBar_heading">ボールペン替芯<br/>かんたん検索</p>
${BallPointPenMakerArea(model)}
${BallPointPenSeriesArea(model)}
${BallPointPenSizesArea(model)}
<button class="m-btn -auto-16 -small" type="button"
  .disabled="${model.selectedMaker === '' || model.selectedSeries === ''}"
  @click="${() => window.location.href = BASE_URL + CreateUrl(model)}">
  <span class="m-btn_inner">
    <span class="m-btn_text">検索</span>
  </span>
</button>
</div>
`;

const CreateUrl = (model: BallPointPenJsEnv) => {
  return `ksearch/?` +
  `refineKbn=${REFINEMENT_SEARCH_TYPE_BALLPOINTPEN}&` +
  `refineCD1=${encodeString(model.selectedMaker)}&` +
  `refineCD2=${encodeString(model.selectedSeries)}&` +
  `refineCD3=${encodeString(model.selectedSize)}&` +
  `callBackKbn=REFILL${window.location.pathname}`;
}
